import { PureComponent } from 'react';

import { getCurrentUserEvents } from '../api/users-api';

import { remoteLog } from 'shared-services/logger-service';
import { delay } from 'utils/helpers';

export default class SocketEventsRestorer extends PureComponent {
    async restore(from, offset = 0, limit = 150, attempt = 0) {
        if (!this.props.teamToken) {
            return Promise.resolve();
        }

        try {
            const response = await getCurrentUserEvents({ from, offset, limit });

            if (response) {
                this.props.onEvents(response.events);
                // remoteLog(`Get events ${new Date(from).toISOString()}: ${response.events.length}`, from, response);

                if (response.hasMore) {
                    return this.restore(from, offset + limit, limit);
                }
            }
        } catch (e) {
            attempt += 1;

            if (e.response?.data?.message === 'Unauthorized' || attempt >= 10) {
                return Promise.reject();
            }

            await delay(attempt * 2000);
            return this.restore(from, offset, limit, attempt);
        }

        return delay(1000);
    }

    componentDidMount() {
        const ctrl = {
            restore: from => {
                // remoteLog(`Before get events ${new Date(from).toISOString()}`, from);
                return this.restore(from);
            }
        };

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = ctrl;
            } else {
                this.props.provideController && this.props.provideController(ctrl);
            }
        }
    }

    componentWillUnmount() {
        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = null;
            } else {
                this.props.provideController && this.props.provideController(null);
            }
        }
    }

    render() {
        return null
    }
};
